export const v86 = {
    default: "#802C7E",
    subtle: "#9E4A9C",
    strong: "#711A6F",
};
